import Button from "app/components/Button";
import { ReactComponent as GoogleSocial } from "app/assets/icons/google-social.svg";
import { firebaseApp } from "app/lib/firebase";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";


interface Props {
  onAuthenticated: (idToken: string) => void;
  loading?: boolean;
}
export default function GoogleAuthFirebase({ onAuthenticated, loading }: Props) {

  const handleSignIn = async () => {
    const auth = getAuth(firebaseApp);
    const provider = new GoogleAuthProvider();
    const result = await signInWithPopup(auth, provider);
    const credential = GoogleAuthProvider.credentialFromResult(result);
    const token = credential?.idToken;
    if (token) {
      onAuthenticated(token);
    }
  }

  return (
    <Button
      type="button"
      variant="secondary"
      size="xBig"
      tw="w-full"
      onClick={handleSignIn}
      loading={loading}
      icon={<GoogleSocial tw="w-[24px] h-[24px]" />}
    >
      Continue with Google
    </Button>
  );
}
